var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.loading
    ? _c("Loading")
    : _c(
        "Box",
        { staticClass: "invoice-container", attrs: { display: "flex" } },
        [
          _c(
            "Card",
            { staticClass: "invoice", attrs: { flex: 2 } },
            [
              _c(
                "Box",
                {
                  attrs: {
                    tag: "header",
                    display: "flex",
                    marginBottom: 9,
                    flexAlign: "center"
                  }
                },
                [
                  _c(
                    "Box",
                    { staticClass: "details" },
                    [
                      _c("layoutText", [_vm._v("July 24th, 2019")]),
                      _c("br"),
                      _c("layoutText", [_vm._v("John Smith")]),
                      _c("layoutText", [_vm._v("11 Broadway")]),
                      _c("layoutText", [_vm._v("New York, NY 10004")])
                    ],
                    1
                  ),
                  _c(
                    "Box",
                    { staticClass: "logo" },
                    [
                      !_vm.state.logoFile.file
                        ? _c("Box", [
                            _c("img", {
                              attrs: {
                                src:
                                  "https://res.cloudinary.com/orthodox-union/image/upload/v1575887944/logo-placeholder_lvxriu.jpg",
                                alt: "Logo"
                              }
                            })
                          ])
                        : _vm._e(),
                      _vm.campaignId
                        ? _c(
                            "Box",
                            [
                              _vm.state.logoFile.status === "failed"
                                ? _c("div", { staticClass: "logo-error" }, [
                                    _vm._v("Error uploading file")
                                  ])
                                : _vm._e(),
                              _vm.state.logoFile.file
                                ? _c(
                                    "Box",
                                    { staticClass: "image-box" },
                                    [
                                      _c("GetSignedUrl", {
                                        attrs: {
                                          filename: _vm.state.logoFile.file
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function({ url }) {
                                                return [
                                                  _c("img", {
                                                    attrs: { src: url }
                                                  })
                                                ]
                                              }
                                            }
                                          ],
                                          null,
                                          false,
                                          478566660
                                        )
                                      })
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _c("S3Uploader", {
                                attrs: { location: "logo" },
                                on: {
                                  input: function($event) {
                                    return _vm.onLogoChanged($event)
                                  }
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "Box",
                { staticClass: "main-text" },
                [
                  _c(
                    "layoutFormRow",
                    [
                      _c(
                        "Box",
                        { attrs: { flex: 1 } },
                        [
                          _c("UILabel", { attrs: { text: "Template Name" } }),
                          _c("FancySelect", {
                            attrs: {
                              clearable: false,
                              options: _vm.nameOptions
                            },
                            model: {
                              value: _vm.state.templateNameValue,
                              callback: function($$v) {
                                _vm.$set(_vm.state, "templateNameValue", $$v)
                              },
                              expression: "state.templateNameValue"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "layoutFormRow",
                    [
                      _c(
                        "Box",
                        { attrs: { flex: 1 } },
                        [
                          _c("UILabel", { attrs: { text: "First line" } }),
                          _c("UIInput", {
                            model: {
                              value: _vm.state.firstLine,
                              callback: function($$v) {
                                _vm.$set(_vm.state, "firstLine", $$v)
                              },
                              expression: "state.firstLine"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "layoutFormRow",
                    [
                      _c(
                        "Box",
                        { attrs: { flex: 1 } },
                        [
                          _c("WysiwygEditor", {
                            attrs: {
                              placeholder: "Enter the text here",
                              toolbarExtras: _vm.toolbarExtras
                            },
                            model: {
                              value: _vm.state.body,
                              callback: function($$v) {
                                _vm.$set(_vm.state, "body", $$v)
                              },
                              expression: "state.body"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm.campaignId
                    ? _c(
                        "layoutFormRow",
                        [
                          _c(
                            "Box",
                            { attrs: { flex: 1 } },
                            [
                              _c("UILabel", { attrs: { text: "Footer line" } }),
                              _c("UIInput", {
                                model: {
                                  value: _vm.state.footerLine,
                                  callback: function($$v) {
                                    _vm.$set(_vm.state, "footerLine", $$v)
                                  },
                                  expression: "state.footerLine"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    "layoutFormRow",
                    [
                      _c(
                        "Box",
                        { attrs: { flex: 1 } },
                        [
                          _c("UILabel", { attrs: { text: "Email Text" } }),
                          _c("WysiwygEditor", {
                            attrs: {
                              placeholder: "Enter the text here",
                              toolbarExtras: _vm.toolbarExtras
                            },
                            model: {
                              value: _vm.state.emailText,
                              callback: function($$v) {
                                _vm.$set(_vm.state, "emailText", $$v)
                              },
                              expression: "state.emailText"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm.campaignId || _vm.department
                    ? _c(
                        "layoutFormRow",
                        [
                          _c("UILabel", {
                            attrs: { text: "Remove Signature from Email:" }
                          }),
                          _c("UICheckbox", {
                            staticStyle: { "margin-left": "10px" },
                            model: {
                              value: _vm.state.removeSignature,
                              callback: function($$v) {
                                _vm.$set(_vm.state, "removeSignature", $$v)
                              },
                              expression: "state.removeSignature"
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.department || _vm.campaignId
                    ? _c(
                        "layoutFormRow",
                        [
                          _c(
                            "Box",
                            { attrs: { flex: "1" } },
                            [
                              _c("UILabel", {
                                attrs: { text: "Salutation", for: "salutation" }
                              }),
                              _c(
                                "RadioGroup",
                                {
                                  model: {
                                    value: _vm.state.salutationType,
                                    callback: function($$v) {
                                      _vm.$set(_vm.state, "salutationType", $$v)
                                    },
                                    expression: "state.salutationType"
                                  }
                                },
                                _vm._l(_vm.salutations, function(salutation) {
                                  return _c("RadioGroupItem", {
                                    key: salutation.value,
                                    attrs: { value: salutation.value },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function({ props, listeners }) {
                                            return [
                                              _c(
                                                "UIRadio",
                                                _vm._g(
                                                  _vm._b(
                                                    {
                                                      attrs: {
                                                        labelText:
                                                          salutation.label
                                                      }
                                                    },
                                                    "UIRadio",
                                                    props,
                                                    false
                                                  ),
                                                  listeners
                                                )
                                              )
                                            ]
                                          }
                                        }
                                      ],
                                      null,
                                      true
                                    )
                                  })
                                }),
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    "UIButton",
                    {
                      staticClass: "blue",
                      attrs: {
                        size: "2",
                        inverted: "true",
                        disabled: !_vm.dirty
                      },
                      on: {
                        click: function($event) {
                          return _vm.saveTemplate()
                        }
                      }
                    },
                    [
                      _c(
                        "layoutText",
                        [
                          _vm._v(" Save "),
                          _vm.dirty ? [_vm._v("*")] : _vm._e()
                        ],
                        2
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c("Box", { staticClass: "signature" }, [
                _vm._v(" Sincerely, "),
                _c("br"),
                _c("img", {
                  staticClass: "signature-img",
                  attrs: {
                    src:
                      "https://res.cloudinary.com/orthodox-union/image/upload/v1557784529/jlic/Rabbi-Pinny-Rosenthal-Signature.jpg"
                  }
                }),
                _c("br"),
                _vm._v("FirstName LastName "),
                _c("br"),
                _vm._v("Position ")
              ]),
              _c(
                "Box",
                { staticClass: "tagline" },
                [
                  _c(
                    "layoutText",
                    {
                      staticClass: "text-center",
                      attrs: { fontSize: 2, color: "#385da3" }
                    },
                    [_vm._v("Because Everyone Belongs")]
                  )
                ],
                1
              ),
              _c(
                "Box",
                { staticClass: "acknowledgment", attrs: { marginTop: 4 } },
                [
                  _c("Box", { staticClass: "acknowledgment-separator" }),
                  _c(
                    "Box",
                    { attrs: { tag: "header" } },
                    [
                      _c(
                        "layoutText",
                        {
                          staticClass: "text-center",
                          attrs: {
                            fontSize: 2,
                            fontWeight: "bold",
                            color: "#222"
                          }
                        },
                        [_vm._v("Official Acknowledgment")]
                      )
                    ],
                    1
                  ),
                  _c(
                    "UITable",
                    { staticClass: "small" },
                    [
                      _c(
                        "TableBody",
                        [
                          _c(
                            "TableRow",
                            [
                              _c("TableCell", [_c("b", [_vm._v("Name")])]),
                              _c("TableCell", [_vm._v("BothTitles_Lastname")]),
                              _c("TableCell", [
                                _c("b", [_vm._v("Account ID")])
                              ]),
                              _c("TableCell", [_vm._v("ACT_ID")])
                            ],
                            1
                          ),
                          _c(
                            "TableRow",
                            [
                              _c("TableCell", [
                                _c("b", [_vm._v("Donation Date")])
                              ]),
                              _c("TableCell", [
                                _vm._v("FORMAT | {0:MMMM dd, yyyy} | PMT_Date")
                              ]),
                              _c("TableCell", [
                                _c("b", [_vm._v("Type of Payment")])
                              ]),
                              _c("TableCell", [_vm._v("PMM_Type")])
                            ],
                            1
                          ),
                          _c(
                            "TableRow",
                            [
                              _c("TableCell", [_c("b", [_vm._v("Amount")])]),
                              _c("TableCell", [_vm._v("PMT_Amount")]),
                              _c("TableCell", [_c("b", [_vm._v("Fund")])]),
                              _c("TableCell", [_vm._v("OCC_Name")])
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "Box",
                {
                  attrs: {
                    tag: "footer",
                    marginTop: 9,
                    display: "flex",
                    flexAlign: "flex-end"
                  }
                },
                [
                  _c("img", {
                    staticClass: "footer-img",
                    attrs: {
                      src:
                        "https://res.cloudinary.com/orthodox-union/image/upload/v1573498550/invoice_footer_xinw7l.png",
                      alt: "OU.org"
                    }
                  })
                ]
              )
            ],
            1
          ),
          _vm.showFundraiser
            ? _c(
                "Box",
                {
                  staticClass: "fundraiser",
                  attrs: { flex: 1, marginLeft: 3 }
                },
                [
                  _c(
                    "Card",
                    [
                      _c(
                        "Box",
                        { attrs: { tag: "header", marginBottom: 4 } },
                        [
                          _c("layoutText", { attrs: { fontWeight: "bold" } }, [
                            _vm._v("Select Fundraiser")
                          ])
                        ],
                        1
                      ),
                      _c(
                        "layoutFormRow",
                        { staticClass: "inlineLabel bigger" },
                        [
                          _c("UserLookup", {
                            staticStyle: { width: "100%" },
                            attrs: {
                              value: _vm.state.fundraiserId,
                              clearable: "",
                              filterActive: true
                            },
                            on: { input: _vm.handleFundraiserChange }
                          })
                        ],
                        1
                      ),
                      _vm.campaignId &&
                      _vm.campaignId == "06d61a4e-931d-4672-b01e-065c12121bfe"
                        ? _c(
                            "layoutFormRow",
                            { staticClass: "inlineLabel bigger" },
                            [
                              _c("UserLookup", {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  value: _vm.state.secondFundraiserId,
                                  clearable: "",
                                  filterActive: true
                                },
                                on: { input: _vm.handleSecondFundraiserChange }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.campaignId &&
                      _vm.campaignId == "06d61a4e-931d-4672-b01e-065c12121bfe"
                        ? _c(
                            "layoutFormRow",
                            { staticClass: "inlineLabel bigger" },
                            [
                              _c("UserLookup", {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  value: _vm.state.thirdFundraiserId,
                                  clearable: "",
                                  filterActive: true
                                },
                                on: { input: _vm.handleThirdFundraiserChange }
                              })
                            ],
                            1
                          )
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e()
        ],
        1
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }